/**
 * Customer Groups Page
 * Ügyfélcsoportok oldal
 */

import React, { useState } from 'react';
import CommonPageHeader from '../components/common/CommonPageHeader';
import CustomerGroupsComponent from '../components/customers/CustomerGroups';
import CustomerGroupEditor from '../components/customers/CustomerGroupEditor';
import { UserGroupIcon, PlusIcon } from '@heroicons/react/24/outline';

const CustomerGroups: React.FC = () => {
  const [isCreating, setIsCreating] = useState(false);

  return (
    <div className="space-y-4">
      <CommonPageHeader
        title="Ügyfélcsoportok"
        subtitle="Csoportosítsd ügyfeleidet kampányokhoz és szegmentációhoz"
        icon={UserGroupIcon}
      >
        <button
          onClick={() => setIsCreating(true)}
          className="bg-white/20 backdrop-blur-sm text-white px-3 py-2 rounded-md text-sm flex items-center justify-center hover:bg-white/30 transition-colors"
        >
          <PlusIcon className="h-4 w-4 mr-2" />
          <span>Új csoport</span>
        </button>
      </CommonPageHeader>
      
      <CustomerGroupsComponent />

      {/* Create Modal */}
      {isCreating && (
        <CustomerGroupEditor
          onClose={() => setIsCreating(false)}
        />
      )}
    </div>
  );
};

export default CustomerGroups;
